export default __webpack_public_path__ + "static/media/microphone-light.9fb7c898.svg";